// extracted by css-extract-rspack-plugin
export default {"cls1":"Accordion-cls1_y25","cls2":"Accordion-cls2_IXq Accordion-cls1_y25","open":"Accordion-open_Ff3"};